import React from 'react';


const StatusTabs = ({ statusTabs, activeTab, onTabClick, hasTabClicked, onClearClick }) => {
  return (
    <div className="max-w-full">
    <div className="flex flex-wrap gap-2 origin-top-left scale-[0.8]">

      {statusTabs?.map((tab) => (
        <button
          key={tab.status}
          onClick={() => onTabClick(tab.status, tab.count)}
          className={`text-sm px-3 py-1 rounded-full border-2 transition
            ${activeTab === tab.status
              ? "bg-white text-primary border-primary"
              : "bg-primary text-secondary border-primary"
            }`}
        >
          {tab.status} ({tab.count})
        </button>
      ))}
      {hasTabClicked  && (
        <button
          key="CLEAR"
          onClick={onClearClick}
          className="text-sm px-3 py-1 rounded-full border-2 transition bg-red-500 text-white border-red-500 hover:bg-red-600"
        >
          ❌
        </button>
      )}
      </div>
    </div>
  );
};

export default StatusTabs;